import { LoadStatus, LoadStatusEnum } from "api/rest/load-status-updates/types";

export default function isLoadStatusComplete(loadStatus: LoadStatus | null | undefined): boolean {
  return (
    loadStatus === LoadStatusEnum.COMPLETED ||
    loadStatus === LoadStatusEnum.COMPLETED_LATE ||
    loadStatus === LoadStatusEnum.COMPLETED_LATE_PARTNER_NOT_AT_FAULT
  );
}
